import { css, styled } from "@mui/material";
import { Checkbox } from "@procore/core-react";

import { type GroupState } from "utils/treeHelpers";

interface TreeNodeCheckboxProps {
    selected: GroupState;
    onSelection: () => void;
}

const CheckboxTapTarget = styled("button")(
    () => css`
        width: 24px;
        min-width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        flex-shrink: 0;
        touch-action: manipulation;
        appearance: none;
        -webkit-appearance: none;
    `,
);

const VisualCheckbox = styled("span")(
    () => css`
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
    `,
);

export function TreeNodeCheckbox({ selected, onSelection }: TreeNodeCheckboxProps) {
    return (
        <CheckboxTapTarget type="button" onClick={onSelection}>
            <VisualCheckbox>
                <Checkbox checked={selected === "all"} indeterminate={selected === "some"} onChange={() => undefined} />
            </VisualCheckbox>
        </CheckboxTapTarget>
    );
}
